export default {
  facebook: "facebook",
  "google-oauth2": "google",
  apple: "apple",
  windowslive: "windowslive",
  linkedin: "linkedin",
  sinuna: "sinuna",
};
